import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiAddQuestionChangeStrategy } from '../../../../bases';
import { FillInBlankDescription } from '../components';
import { jsx as _jsx } from "react/jsx-runtime";
export var FillInBlankAddQuestionStrategy = /*#__PURE__*/function (_AiAddQuestionChangeS) {
  _inherits(FillInBlankAddQuestionStrategy, _AiAddQuestionChangeS);

  var _super = _createSuper(FillInBlankAddQuestionStrategy);

  function FillInBlankAddQuestionStrategy(context) {
    _classCallCheck(this, FillInBlankAddQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(FillInBlankAddQuestionStrategy, [{
    key: "renderAnswers",
    value: function renderAnswers() {
      var _after$description, _after$index;

      var after = this.context.after;
      return /*#__PURE__*/_jsx(FillInBlankDescription, {
        description: (_after$description = after === null || after === void 0 ? void 0 : after.description) !== null && _after$description !== void 0 ? _after$description : '',
        beforeQuestion: undefined,
        afterQuestion: after,
        changeType: this.context.changeType,
        startQuestionIndex: (_after$index = after === null || after === void 0 ? void 0 : after.index) !== null && _after$index !== void 0 ? _after$index : 1
      });
    }
  }]);

  return FillInBlankAddQuestionStrategy;
}(AiAddQuestionChangeStrategy);